

import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { ChangeHighlighter } from '@rd-web-markets/shared/dist/util';
import { createTimezonedDate } from '@rd-web-markets/shared/dist/util/date';
import { useTranslation } from 'react-i18next';
import AlertPopup from '@rd-web-markets/shared/dist/AlertPopup';

const AttachmentItem = ({index, attachment, handleAttachmentChange, handleAttachmentSubmit, handleDelete, applicationSubmitted}) => {
  const { t } = useTranslation();
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const deleteAttachment = async () => {
    if (window.MARKET_CONSTANTS.SHOW_ALERT_POPUP_FOR_DELETE_DOCUMENT_ATTACHMENT_COMPONENT) {
      setShowDeleteModal(true);
    } else {
      await handleDelete(attachment.id);
    }
  }

  return (
    <>
      <AlertPopup
        onHide={() => setShowDeleteModal(false)}
        show={showDeleteModal}
        message={t('are_you_sure_that_you_want_to_delete_this_document')}
        buttonProps={[
          {
            text: t('yes'),
            buttonAction: () => handleDelete(attachment.id),
            style: {},
            className: 'me-3',
            buttonVariant: 'success'
          },
          {
            text: t('no'),
            buttonAction: () => setShowDeleteModal(false),
            style: {},
            className: 'me-3',
            buttonVariant: 'danger'
          }
        ]}
      />

      <tr key={attachment.id}>
        <td>{createTimezonedDate(new Date(attachment.created_at), true).toCustomLocaleDateString()}</td>
        <td>
          <a 
            href={attachment.download_link.url} target="_blank" rel="noreferrer"
          >
            {attachment.download_link.filename}
          </a>
        </td>
        <td>
          <ChangeHighlighter
            as={Form.Control}
            onChange={e => handleAttachmentChange(e, index)}
            onBlur={() => handleAttachmentSubmit(index)}
            object={attachment}
            name="notes"
            disabled={applicationSubmitted}
          />
        </td>
        <td>
          <Button
            variant="danger"
            disabled={applicationSubmitted}
            onClick={() => deleteAttachment()}
            className="mx-2">
            <span className="material-icons md-18">delete</span>
          </Button>
        </td>
      </tr>
    </>
  )
}

export default AttachmentItem
